import { Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { MbmModalComponent } from '@modals';
import { MbmButtonComponent, type MbmButtonVariant } from '@components';

@Component({
  selector: 'mbm-confirmation-modal',
  imports: [TranslateModule, MbmModalComponent, MbmButtonComponent],
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss',
})
export class ConfirmationModalComponent {
  private readonly modalController = inject(ModalController);

  // Set via Ionic componentProps — plain properties for compatibility
  titleKey = 'general.confirmation';
  subtitleKey?: string;
  messageKey = '';
  messageParams: Record<string, unknown> = {};
  confirmTextKey = 'general.confirm';
  cancelTextKey = 'general.cancel';
  confirmVariant: MbmButtonVariant = 'primary';
  /** Info-only popup: a single confirm button, no cancel. */
  hideCancel = false;

  protected onConfirm(): void {
    void this.modalController.dismiss(null, 'confirm');
  }

  protected onCancel(): void {
    void this.modalController.dismiss(null, 'cancel');
  }
}
